import React, { useCallback, Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import helpers from 'helpers';

import { MINIMUM_DEPOSIT_AMOUNT } from '../../../constants';

import Button from '@xanadu/ui-shared/components/widgets/Button';

import styles from './ModalContent.module.scss';

const currencyFormatter = helpers.localise.currency;

const ModalContent = ({
  closeModal = () => { },
  remaining,
  limit,
  history: { push: navigateTo }
}) => {
  const limitReached = remaining === 0;

  const linkTo = useCallback(() => {
    closeModal();

    const timer = setTimeout(() => {
      navigateTo('/account/safer-gambling');
    }, 240);

    return () => {
      clearTimeout(timer);
    };
  }, []);

  const primaryButtonClass = classNames({
    [styles.primaryButton]: true,
    [`mb-button ${styles.button}`]: true
  });

  return (
    <Fragment>
      <div className={styles.main}>
        <div>
          <div className={styles.title}>
            {limitReached ? (
              'Net Deposit Limit Reached'
            ) : (
              'Net Deposit Limit Insufficient'
            )}
          </div>
          <div className={styles.bold}>
            {limitReached ? (
              `Your Net Deposit Limit of ${currencyFormatter(limit)} has been reached.`
            ) : (
              `Your remaining Net Deposit Limit of ${currencyFormatter(remaining)} is below our minimum deposit amount of ${currencyFormatter(MINIMUM_DEPOSIT_AMOUNT)}`
            )}
          </div>
          <span>{'Your Net Deposit Amount is your Total Deposits minus your Total Withdrawals, calculated over a rolling 30 day period.'}</span>
        </div>
        <div className={styles.containerActions}>
          <Button
            buttonType="flat"
            className={styles.button}
            disabled={false}
            onClick={closeModal}
            sizeType="wider"
          >
            close
          </Button>
          <Button
            buttonType="primary"
            className={primaryButtonClass}
            onClick={linkTo}
            sizeType="wider"
          >
            review your limits
          </Button>
        </div>
      </div>
    </Fragment>
  );
};

ModalContent.propTypes = {
  closeModal: PropTypes.func.isRequired,
  remaining: PropTypes.number.isRequired,
  limit: PropTypes.number.isRequired,
  history: PropTypes.shape({
    push: PropTypes.func.isRequired
  })
};

export default withRouter(ModalContent);
